var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-preview", attrs: { id: "contents" } }, [
    _c("div", { staticClass: "company-area" }, [
      _c(
        "p",
        { staticClass: "company-name", attrs: { "data-test": "company-name" } },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.jobSearchResult.companyName) + "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "company-title", attrs: { "data-test": "job-title" } },
        [
          _c("a", [_vm._v(_vm._s(_vm.jobSearchResult.jobTitle))]),
          _vm._v(" "),
          _c("job-employment-status-sp", {
            attrs: { "employment-status": _vm.employmentStatus },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "company-day" }, [
        _c("p", { staticClass: "icon" }, [
          _c("img", {
            staticClass: "new-icon",
            attrs: {
              src: _vm.userOfferImageUrlForSp + "/icon_company_new.png",
              alt: "NEW",
              "data-test": "new-icon",
            },
          }),
          _vm._v(" "),
          _vm.jobSearchResult.isSimple &&
          !_vm.jobSearchResult.isOriginalEntryForm
            ? _c("img", {
                staticClass: "simple-interview-icon",
                attrs: {
                  src: _vm.userOfferImageUrlForSp + "/icon_company_simple.png",
                  alt: "シンプル応募",
                  "data-test": "simple-icon",
                },
              })
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "contents-inner" },
      [
        _c(
          "p",
          { staticClass: "company-lead", attrs: { "data-test": "catch-copy" } },
          [
            _c("span", {
              staticClass: "pega-pre-wrap job-search-main-title",
              domProps: { textContent: _vm._s(_vm.jobSearchResult.mainTitle) },
            }),
          ]
        ),
        _vm._v(" "),
        _vm.jobSearchResult.mainPhoto &&
        _vm.jobSearchResult.isExistsPremiumImage
          ? _c("div", { staticClass: "company-intro -offer" }, [
              _c("p", [
                _c("img", {
                  staticClass: "premium-img",
                  attrs: {
                    id: _vm.jobSearchResult.mainPhoto.id,
                    src: _vm.getPhotoUrl(_vm.jobSearchResult.mainPhoto),
                    "data-test": "premium-photo",
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "company-intro -offer" }, [
          _c("div", { staticClass: "text" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "lead-text mt10",
                attrs: { "data-test": "job-content-inner" },
              },
              [
                _c("span", {
                  staticClass: "pega-pre-wrap",
                  domProps: {
                    textContent: _vm._s(_vm.jobSearchResult.catchCopy),
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.jobSearchResult.mainPhoto &&
          !_vm.jobSearchResult.isExistsPremiumImage
            ? _c("div", { staticClass: "photo" }, [
                _c("p", [
                  _c("img", {
                    staticClass: "max-w100",
                    attrs: {
                      id: _vm.jobSearchResult.mainPhoto.id,
                      src: _vm.getPhotoUrl(_vm.jobSearchResult.mainPhoto),
                      "data-test": "offer-main-image",
                    },
                  }),
                ]),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("job-appeal-point-sp", {
          attrs: { "pr-codes": _vm.prCodes, "is-search-result": true },
        }),
        _vm._v(" "),
        _c("table", { staticClass: "table-type-01" }, [
          _c("tbody", [
            _c("tr", [
              _c("th", { staticClass: "w25" }, [
                _vm._v("\n            応募資格\n          "),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "w75" }, [
                _c(
                  "p",
                  {
                    staticClass: "text-ellipsis-02",
                    attrs: { "data-test": "offer-required-inner" },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.jobSearchResult.requiredSkill) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", { staticClass: "w25" }, [
                _vm._v("\n            給与\n          "),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "w75" }, [
                _c(
                  "p",
                  {
                    staticClass: "text-ellipsis-02",
                    attrs: { "data-test": "salary-inner" },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.jobSearchResult.salary) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", { staticClass: "w25" }, [
                _vm._v("\n            勤務地\n          "),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "w75" }, [
                _c(
                  "p",
                  {
                    staticClass: "text-ellipsis-02",
                    attrs: { "data-test": "place-inner" },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.jobSearchResult.place) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm._m(1),
          ]),
        ]),
        _vm._v(" "),
        !_vm.jobSearchResult.isLightPlan && _vm.jobSearchResult.report.body
          ? _c("div", { staticClass: "viewpoint -bg-pink" }, [
              _c("div", { staticClass: "left" }, [
                _c("img", {
                  attrs: {
                    src: _vm.userCommonImageUrlForSp + "/viewpoints.png",
                    alt: "view point",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "right" }, [
                _c("p", { attrs: { "data-test": "report" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.jobSearchResult.report.body) +
                      "\n        "
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-type-01 mt15" }, [
          _c("div", { staticClass: "-block w49" }, [
            _c("a", { staticClass: "link-button review" }, [
              _c("img", {
                staticClass: "heart",
                attrs: {
                  src: _vm.userCommonImageUrlForSp + "/icon_heart_sp.png",
                },
              }),
              _vm._v("気になる\n        "),
            ]),
          ]),
          _vm._v(" "),
          _vm._m(2),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "search-result-border-sp" }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hd-type-04 m0" }, [
      _c("span", [_vm._v("仕事内容")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { staticClass: "w25" }, [
        _vm._v("\n            PR\n          "),
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "w75" }, [
        _c("ul", { staticClass: "appeal-point02" }, [
          _c("li", { attrs: { "data-test": "interview-icon" } }, [
            _vm._v("\n                インタビュー\n              "),
          ]),
          _vm._v(" "),
          _c("li", { attrs: { "data-test": "photo-clip-icon" } }, [
            _vm._v("\n                フォトクリップ\n              "),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "-block w49" }, [
      _c("a", { staticClass: "link-button -type02" }, [_vm._v("詳細を見る")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }